import {
  FETCH_ORDER_ENTRY_CUSTOMERS_REQUEST,
  FETCH_ORDER_ENTRY_CUSTOMERS_SUCCESS,
  FETCH_ORDER_ENTRY_CUSTOMERS_FAILURE,
  FETCH_ORDER_ENTRY_VENDORS_SUCCESS,
  FETCH_ORDER_ENTRY_VENDORS_FAILURE,
  FETCH_ORDER_ENTRY_VENDORS_REQUEST,
  ADD_UPDATE_ORDER_ENTRY_CUSTOMER_REQUEST,
  ADD_UPDATE_ORDER_ENTRY_CUSTOMER_SUCCESS,
  ADD_UPDATE_ORDER_ENTRY_CUSTOMER_FAILURE,
  ADD_UPDATE_ORDER_ENTRY_VENDOR_REQUEST,
  ADD_UPDATE_ORDER_ENTRY_VENDOR_SUCCESS,
  ADD_UPDATE_ORDER_ENTRY_VENDOR_FAILURE,
  FETCH_CUSTOMER_REFERENCES_REQUEST,
  FETCH_CUSTOMER_REFERENCES_SUCCESS,
  FETCH_CUSTOMER_REFERENCES_FAILURE,
  FETCH_LOZIER_DIMENSIONS_REQUEST,
  FETCH_LOZIER_DIMENSIONS_SUCCESS,
  FETCH_LOZIER_DIMENSIONS_FAILURE,
  FETCH_VENDORSERVICETYPES_REQUEST,
  FETCH_VENDORSERVICETYPES_SUCCESS,
  FETCH_VENDORSERVICETYPES_FAILURE,
  ADD_UPDATE_VENDORSERVICETYPES_REQUEST,
  ADD_UPDATE_VENDORSERVICETYPES_SUCCESS,
  ADD_UPDATE_VENDORSERVICETYPES_FAILURE,
} from "./actionTypes";
import { CustomersState, VendorsState, VendorServiceTypesState } from "./types";
import { combineReducers } from "redux";

const customersInitialState: CustomersState = {
  customers: [],
  loadingScreen: false,
  error: null,
  successMessage: "",
  pending: false,
  totalCount: 0,
  dropdownCustomers: [],
  customerReferences: [],
  weightDimensions: [],
};

const vendorsInitialState: VendorsState = {
  vendors: [],
  loadingScreen: false,
  error: null,
  successMessage: "",
  pending: false,
  totalCount: 0,
  dropdownVendors: [],
};

const vendorServiceTypesInitialState: VendorServiceTypesState = {
  vendorServiceTypes: [],
  loadingScreen: false,
  error: null,
  successMessage: "",
  pending: false,
  totalCount: 0,
};

// Customers reducer
export const customersReducer = (
  state = customersInitialState,
  action: any,
): CustomersState => {
  switch (action.type) {
    case FETCH_ORDER_ENTRY_CUSTOMERS_REQUEST:
      return {
        ...state,
        loadingScreen: true,
        error: null,
      };

    case FETCH_ORDER_ENTRY_CUSTOMERS_SUCCESS:
      return {
        ...state,
        loadingScreen: false,
        customers: action.payload.customers,
        totalCount: action.payload.totalCount,
      };

    case FETCH_ORDER_ENTRY_CUSTOMERS_FAILURE:
      return {
        ...state,
        loadingScreen: false,
        error: action.payload,
      };

    case ADD_UPDATE_ORDER_ENTRY_CUSTOMER_REQUEST:
      return {
        ...state,
        pending: true,
        error: null,
      };

    case ADD_UPDATE_ORDER_ENTRY_CUSTOMER_SUCCESS:
      return {
        ...state,
        pending: false,
        successMessage: action.payload.successMessage,
      };

    case ADD_UPDATE_ORDER_ENTRY_CUSTOMER_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload,
      };

    case FETCH_CUSTOMER_REFERENCES_REQUEST:
      return {
        ...state,
        error: null,
      };

    case FETCH_CUSTOMER_REFERENCES_SUCCESS:
      return {
        ...state,
        customerReferences: action.payload.customerReferences,
      };

    case FETCH_CUSTOMER_REFERENCES_FAILURE:
      return {
        ...state,
        error: action.payload,
      };
    case FETCH_LOZIER_DIMENSIONS_REQUEST:
      return {
        ...state,
        error: null,
      };

    case FETCH_LOZIER_DIMENSIONS_SUCCESS:
      return {
        ...state,
        weightDimensions: action.payload.weightDimensions,
      };

    case FETCH_LOZIER_DIMENSIONS_FAILURE:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

// Vendors reducer
export const vendorsReducer = (
  state = vendorsInitialState,
  action: any,
): VendorsState => {
  switch (action.type) {
    case FETCH_ORDER_ENTRY_VENDORS_REQUEST:
      return {
        ...state,
        loadingScreen: true,
        error: null,
      };

    case FETCH_ORDER_ENTRY_VENDORS_SUCCESS:
      return {
        ...state,
        loadingScreen: false,
        vendors: action.payload.vendors,
        totalCount: action.payload.totalCount,
      };

    case FETCH_ORDER_ENTRY_VENDORS_FAILURE:
      return {
        ...state,
        loadingScreen: false,
        error: action.payload,
      };

    case ADD_UPDATE_ORDER_ENTRY_VENDOR_REQUEST:
      return {
        ...state,
        pending: true,
        error: null,
      };

    case ADD_UPDATE_ORDER_ENTRY_VENDOR_SUCCESS:
      return {
        ...state,
        pending: false,
        successMessage: action.payload.successMessage,
      };

    case ADD_UPDATE_ORDER_ENTRY_VENDOR_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

// Vendor service types reducer
export const vendorServiceTypesReducer = (
  state = vendorServiceTypesInitialState,
  action: any,
): VendorServiceTypesState => {
  switch (action.type) {
    case FETCH_VENDORSERVICETYPES_REQUEST:
      return {
        ...state,
        loadingScreen: true,
        error: null,
      };

    case FETCH_VENDORSERVICETYPES_SUCCESS:
      return {
        ...state,
        loadingScreen: false,
        vendorServiceTypes: action.payload.vendorServiceTypes,
        totalCount: action.payload.totalCount,
      };

    case FETCH_VENDORSERVICETYPES_FAILURE:
      return {
        ...state,
        loadingScreen: false,
        error: action.payload,
      };

    case ADD_UPDATE_VENDORSERVICETYPES_REQUEST:
      return {
        ...state,
        pending: true,
        error: null,
      };

    case ADD_UPDATE_VENDORSERVICETYPES_SUCCESS:
      return {
        ...state,
        pending: false,
        successMessage: action.payload.successMessage,
      };

    case ADD_UPDATE_VENDORSERVICETYPES_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

const customersVendorsReducer = combineReducers({
  customers: customersReducer,
  vendors: vendorsReducer,
  vendorServiceTypes: vendorServiceTypesReducer,
});

export default customersVendorsReducer;
